import React from "react";
import { FilePdf, ArrowUpRight, ShieldCheck, Scales } from "@phosphor-icons/react";
import { MaskReveal, FadeUp } from "@/components/Motion";
import { Eyebrow } from "@/components/Shared";

const DOCS = [
  {
    key: "privacy",
    title: "Privacy Policy",
    desc: "How OneLease collects, protects and uses your data.",
    icon: ShieldCheck,
    url: "/OneLease Privacy Policy.pdf",
  },
  {
    key: "terms",
    title: "Terms of Service",
    desc: "The rules and agreement for using OneLease.",
    icon: Scales,
    url: "/OneLease Terms of Service.pdf",
  },
];

export default function PrivacyTerms() {
  return (
    <div data-testid="privacy-terms-page">
      <section className="relative overflow-hidden bg-white pt-28 sm:pt-36 pb-16 sm:pb-24 min-h-[70vh]">
        <div className="absolute inset-0 dot-grid opacity-50" />
        <div className="relative z-10 mx-auto max-w-3xl px-5 sm:px-8">
          <div className="text-center">
            <div className="flex justify-center"><Eyebrow>Legal</Eyebrow></div>
            <h1 className="mt-6 text-[2.2rem] sm:text-5xl font-extrabold tracking-tight text-ol-ink leading-[1.04]">
              <MaskReveal lines={["Privacy & Terms."]} delay={0.1} />
            </h1>
            <p className="mt-5 text-lg text-ol-gray leading-relaxed">
              Read the full OneLease legal documents below.
            </p>
          </div>

          <div className="mt-12 grid gap-5 sm:grid-cols-2">
            {DOCS.map((d, i) => {
              const Icon = d.icon;
              return (
                <FadeUp key={d.key} delay={i * 0.08}>
                  <a
                    href={d.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`legal-link-${d.key}`}
                    className="group flex h-full flex-col rounded-[2rem] bg-white p-7 sm:p-8 soft-shadow-sm hover:-translate-y-1 transition-transform duration-300"
                  >
                    <div className="flex items-start justify-between">
                      <div className="grid place-items-center h-14 w-14 rounded-2xl bg-ol-blue/10 text-ol-blue">
                        <Icon size={28} weight="duotone" />
                      </div>
                      <span className="grid place-items-center h-10 w-10 rounded-full bg-ol-surface text-ol-blue transition-colors duration-200 group-hover:bg-ol-blue group-hover:text-white">
                        <ArrowUpRight size={18} weight="bold" />
                      </span>
                    </div>
                    <h3 className="mt-6 text-xl font-bold text-ol-ink">{d.title}</h3>
                    <p className="mt-2 flex-1 text-ol-gray leading-relaxed">{d.desc}</p>
                    <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-ol-blue">
                      <FilePdf size={18} weight="bold" /> View PDF
                    </span>
                  </a>
                </FadeUp>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
